// Adds transparency to a color given as a hex string or a CSS expression such as var(--lyra-color-primary).
// `hh` is the two-digit hex alpha the old code appended to hex colors ("22" is about 13%).
export function alpha(color, hh) {
  const value = String(color ?? '');
  if (/^#[0-9a-f]{6}$/i.test(value)) return value + hh;
  const percent = Math.round((parseInt(hh, 16) / 255) * 100);
  return `color-mix(in srgb, ${value} ${percent}%, transparent)`;
}
